import {Component} from '@angular/core'
import {LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'

@Component({
  selector: 'spb-home',
  imports: [
    LoginComponent
  ],
  templateUrl: './home.component.html'
})
export class HomeComponent {

}
